// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyASlGldxn-tM7ZskooRRLhvQ-AntRUCQ7g",
    authDomain: "residence-krengo-lama-2e1bc.firebaseapp.com",
    projectId: "residence-krengo-lama-2e1bc",
    storageBucket: "residence-krengo-lama-2e1bc.appspot.com",
    messagingSenderId: "1025471152972",
    appId: "1:1025471152972:web:98711bee08cf32986245e9",
    measurementId: "G-M72CX6P2GS"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
